import { ReactNode, ErrorInfo } from 'react';
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary';
import ErrorPage from './ErrorPage';
import { safeTrackMixpanel } from './mixpanelLogger';

interface ErrorBoundaryProps {
  children: ReactNode;
}

const logErrorToMixpanel = (error: Error, info: ErrorInfo) => {
  safeTrackMixpanel('Error page reached', {
    error_name: error?.name,
    error_message: error?.message,
    error_stack: error?.stack,
    component_stack: info?.componentStack,
  });
};

const ErrorFallback = ({ resetErrorBoundary, error }: FallbackProps) => {
  return (
    <ErrorPage
      error={error}
      resetError={() => {
        resetErrorBoundary();
      }}
    />
  );
};

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback} onError={logErrorToMixpanel}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
